import live from "../assets/brand/Live-Icon.png";
import prisma from "../assets/brand/Prisma-Icon.png";
import affinity from "../assets/brand/Affinity-Icon-New.svg";

export type Family = "live" | "prisma" | "affinity";
export type FamilyIconSize = "xs" | "sm" | "md" | "lg";

// Sourced from future-demand.com's product nav — the canonical marks
// each family ships with publicly. Affinity reuses the app SVG (same artwork).
const SRC: Record<Family, string> = { live, prisma, affinity };
const LABEL: Record<Family, string> = { live: "Live", prisma: "Prisma", affinity: "Affinity" };

const sizeClass: Record<FamilyIconSize, string> = {
  xs: "fd-product-icon--xs",
  sm: "fd-product-icon--sm",
  md: "",
  lg: "fd-product-icon--lg",
};

/** Icon for a Future Demand product family — Live, Prisma, or Affinity. */
export function FamilyIcon({ family, size = "md" }: { family: Family; size?: FamilyIconSize }) {
  const cls = ["fd-product-icon", sizeClass[size]].filter(Boolean).join(" ");
  return (
    <span className={cls} role="img" aria-label={LABEL[family]}>
      <img src={SRC[family]} alt="" />
    </span>
  );
}
